(() => {
  const WIDGET_SELECTOR = [
    '[data-subscription-widget-v1]',
    '[data-subscription-widget-v2]',
    '[data-subscription-widget-v3]',
    '[data-subscription-widget-v4]',
    '[data-quantity-offer-widget-v1]',
    '[data-subscription-v6]'
  ].join(',');
  const CONFIG_SELECTOR = '[data-subscription-v6-config]';
  const refreshedSections = new Map();
  let timer = null;
  let signature = '';

  const getSignature = () => [
    document.documentElement.lang || '',
    window.Shopify?.currency?.active || '',
    window.Shopify?.currency?.rate || '',
    window.location.pathname
  ].join('|');

  signature = getSignature();

  const getVariantId = (container) =>
    container.querySelector('input[name="id"]')?.value ||
    container.querySelector('[data-variant-id]')?.dataset.variantId ||
    '';

  const fetchSection = async (container) => {
    const sectionId = container.dataset.section || container.dataset.sectionId;
    const productUrl = container.dataset.url || window.location.pathname;
    if (!sectionId || !productUrl) return null;

    const url = new URL(productUrl, window.location.origin);
    url.searchParams.set('section_id', sectionId);
    const variantId = getVariantId(container);
    if (variantId) url.searchParams.set('variant', variantId);

    const cacheKey = url.toString();
    if (refreshedSections.has(cacheKey)) return refreshedSections.get(cacheKey);

    const request = fetch(cacheKey, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then((response) => (response.ok ? response.text() : ''))
      .then((text) => (text ? new DOMParser().parseFromString(text, 'text/html') : null))
      .catch(() => null);

    refreshedSections.set(cacheKey, request);
    return request;
  };

  const refreshWidgetConfigs = (currentContainer, sourceHtml) => {
    currentContainer.querySelectorAll(CONFIG_SELECTOR).forEach((configNode) => {
      const sectionId = configNode.dataset.sectionId;
      if (!sectionId) return;
      const escapedSectionId = window.CSS?.escape ? CSS.escape(sectionId) : String(sectionId).replace(/"/g, '\\"');
      const sourceConfig = sourceHtml.querySelector(`${CONFIG_SELECTOR}[data-section-id="${escapedSectionId}"]`);
      if (sourceConfig) configNode.textContent = sourceConfig.textContent;
    });
  };

  const syncNode = (currentNode, sourceNode) => {
    if (!currentNode || !sourceNode) return;
    currentNode.innerHTML = sourceNode.innerHTML;
    currentNode.className = sourceNode.className;
    ['hidden', 'aria-label', 'aria-hidden'].forEach((attribute) => {
      if (sourceNode.hasAttribute(attribute)) currentNode.setAttribute(attribute, sourceNode.getAttribute(attribute) || '');
      else currentNode.removeAttribute(attribute);
    });
  };

  const syncIndexedNodes = (container, sourceHtml, selector) => {
    const currentNodes = Array.from(container.querySelectorAll(selector));
    const sourceNodes = Array.from(sourceHtml.querySelectorAll(selector));
    currentNodes.forEach((currentNode, index) => syncNode(currentNode, sourceNodes[index]));
  };

  const refreshPassivePrices = (container, sourceHtml) => {
    syncIndexedNodes(container, sourceHtml, '[data-main-product-v1-price]');
    syncIndexedNodes(container, sourceHtml, '.main_product_v1__one-time-content');
    syncIndexedNodes(container, sourceHtml, '.main_product_v1__one-time-sold-out');

    const currentButtons = Array.from(container.querySelectorAll('.main_product_v1__one-time-button'));
    const sourceButtons = Array.from(sourceHtml.querySelectorAll('.main_product_v1__one-time-button'));
    currentButtons.forEach((button, index) => {
      const sourceButton = sourceButtons[index];
      if (!sourceButton) return;
      button.setAttribute('aria-label', sourceButton.getAttribute('aria-label') || '');
    });
  };

  const refreshWidgetsInContainer = async (container) => {
    const sourceHtml = await fetchSection(container);
    if (!sourceHtml) return;

    refreshWidgetConfigs(document, sourceHtml);
    refreshPassivePrices(container, sourceHtml);

    container.querySelectorAll(WIDGET_SELECTOR).forEach((currentWidget) => {
      const blockId = currentWidget.dataset.blockId;
      const sourceWidget =
        (blockId &&
          Array.from(sourceHtml.querySelectorAll(WIDGET_SELECTOR)).find((widget) => widget.dataset.blockId === blockId)) ||
        null;
      if (!sourceWidget) return;
      currentWidget.replaceWith(sourceWidget.cloneNode(true));
    });

    document.dispatchEvent(new CustomEvent('shopify:section:load', { detail: { source: 'market-pricing-refresh' } }));
  };

  const refreshMarketPricing = (force = false) => {
    window.clearTimeout(timer);
    timer = window.setTimeout(() => {
      const nextSignature = getSignature();
      if (!force && nextSignature === signature) return;
      signature = nextSignature;
      refreshedSections.clear();
      const containers = document.querySelectorAll('product-info[data-section][data-url], [data-section-id][data-url]');
      containers.forEach(refreshWidgetsInContainer);
    }, 150);
  };

  [
    'shopify:currency:change',
    'shopify:country:change',
    'localization:change',
    'countrychange',
    'currencychange'
  ].forEach((eventName) => document.addEventListener(eventName, () => refreshMarketPricing(true)));

  document.addEventListener('change', (event) => {
    if (event.target?.closest('form[action*="/localization"]')) refreshMarketPricing(true);
  });
  window.addEventListener('pageshow', () => refreshMarketPricing(false));
  window.addEventListener('focus', () => refreshMarketPricing(false));
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) refreshMarketPricing(false);
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => refreshMarketPricing(false), { once: true });
  } else {
    refreshMarketPricing(false);
  }
  window.setTimeout(() => refreshMarketPricing(false), 600);
})();
